import { render, staticRenderFns } from "./EventModalUsers.vue?vue&type=template&id=18add971"
import script from "./EventModalUsers.vue?vue&type=script&lang=js"
export * from "./EventModalUsers.vue?vue&type=script&lang=js"
import style0 from "./EventModalUsers.vue?vue&type=style&index=0&id=18add971&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports